import React, { Component,Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBTableBody,MDBTable, MDBTableHead, MDBAlert, MDBSelect , MDBInput, MDBIcon ,MDBRow, MDBCol,  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import domtoimage from 'dom-to-image';
import { api, URL } from '../../api';

export default class ModalEditshortmodule extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,
  Curriculumopen:[],

  Course_ID:'',
  Curriculumopen_ID:'',
  Course_YEAR:'',
  Curriculumopen_TEAM:'',
  Curriculumopen_Full_Name_TH:'',
  Curriculumopen_Full_Name_EN:'',
  Curriculumopen_Detail_TH:'',
  Curriculumopen_Detail_EN:'',
  Curriculumopen_CH:'',
  Curriculumopen_NUM:'',
  Curriculumopen_Date_STARTRE:'',
  Curriculumopen_Date_ENDRE:'',
  Curriculumopen_Date_START:'',
  Curriculumopen_Date_END:'',
  Curriculumopen_User_UPDATE:'',
  Curriculumopen_Status_COURSE:'1',
  Curriculumopen_Status_ONOFF:'1',
  Univ_ID:'1',
  Univ_NAME:'',

       Shortcoursemd_Course_ID:'',//รหัสวิชาหลัก

        Shortcourse_ID:'',
        Shortcoursemd_Course_ID:'',
        Shortcoursemd_Nameshort_TH:'',
        Shortcoursemd_Nameshort_EN:'',
        Curriculumopen_Detail_THshort:'',
        Curriculumopen_Detail_ENshort:'',
        Shortcoursemd_Numch:'',
        Shortcoursemd_Numregis:'',
        Shortcoursemd_Timestart:'',
        Shortcoursemd_Timeend:'',
        Shortcoursemd_Userupdate:'',
        Shortcoursemd_Status_ONOFF:'1',
        Shortcoursemd_Univ_id:'1',
}

//this.handleChange = this.handleChange.bind(this);
this.handleChangeName_EN = this.handleChangeName_EN.bind(this);
this.handleChangeName_TH = this.handleChangeName_TH.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangeteam = this.handleChangeteam.bind(this);
this.handleChangeCH = this.handleChangeCH.bind(this);
this.handleChangeNUM = this.handleChangeNUM.bind(this);
this.handleChangeTIMESTART = this.handleChangeTIMESTART.bind(this);
this.handleChangeEND = this.handleChangeEND.bind(this);
this.handleChangeDetail_TH = this.handleChangeDetail_TH.bind(this);
this.handleChangeDetail_EN = this.handleChangeDetail_EN.bind(this);
this.handleChangeTIMESTARTRE = this.handleChangeTIMESTARTRE.bind(this);
this.handleChangeENDRE = this.handleChangeENDRE.bind(this);

this.getCurriculumopen = this.getCurriculumopen.bind(this);
this.handleChangenameshortterm = this.handleChangenameshortterm.bind(this);
this.handleChangenameshorttermen = this.handleChangenameshorttermen.bind(this);
this.handleChangeDetail_TH = this.handleChangeDetail_TH.bind(this);
this.handleChangeDetail_EN = this.handleChangeDetail_EN.bind(this);
this.handleChangech = this.handleChangech.bind(this);
this.handleChangeregis = this.handleChangeregis.bind(this);
this.handleChangeTIMESTART = this.handleChangeTIMESTART.bind(this);
this.handleChangeEND = this.handleChangeEND.bind(this);

}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    Shortcoursemd_Course_ID:this.props.Shortcoursemd_Course_ID

    
  });
  this.getCurriculumopen();
}

getCurriculumopen() {
    setTimeout(() => {
       //ภายใน
       api.get('index/getShortcoursemdforedit/'+this.props.Shortcoursemd_ID)
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })

       //  this.setState({ Curriculumopen: res.data})

         
         this.setState({ Shortcourse_ID: res.data[0].Shortcourse_ID})
         this.setState({ Shortcoursemd_Course_ID: res.data[0].Shortcoursemd_Course_ID})
         this.setState({ Shortcoursemd_Nameshort_TH: res.data[0].Shortcoursemd_Nameshort_TH})
         this.setState({ Shortcoursemd_Nameshort_EN: res.data[0].Shortcoursemd_Nameshort_EN})
         this.setState({ Curriculumopen_Detail_THshort: res.data[0].Curriculumopen_Detail_THshort})
         this.setState({ Curriculumopen_Detail_ENshort: res.data[0].Curriculumopen_Detail_ENshort})
         this.setState({ Shortcoursemd_Numch: res.data[0].Shortcoursemd_Numch})
         this.setState({ Shortcoursemd_Numregis: res.data[0].Shortcoursemd_Numregis})
         this.setState({ Shortcoursemd_Timestart: res.data[0].Shortcoursemd_Timestart})
         this.setState({ Shortcoursemd_Timeend: res.data[0].Shortcoursemd_Timeend})
         this.setState({ Shortcoursemd_Userupdate: res.data[0].Shortcoursemd_Userupdate})
      
       }) 
     }, 0);
  }


//handleChange2(event) {    this.setState({send_comment1: event.target.value});  }


 componentDidMount() {

  const { Shortcoursemd_ID } = this.props.Shortcoursemd_ID
console.log(Shortcoursemd_ID)


  }



  handleChangeteam(event) {    this.setState({Curriculumopen_TEAM: event.target.value});  }
  handleChangeName_TH(event) {    this.setState({Curriculumopen_Full_Name_TH: event.target.value});  }
  handleChangeName_EN(event) {    this.setState({Curriculumopen_Full_Name_EN: event.target.value});  }
  handleChangeDetail_TH(event) {    this.setState({Curriculumopen_Detail_TH: event.target.value});  }
  handleChangeDetail_EN(event) {    this.setState({Curriculumopen_Detail_EN: event.target.value});  }
  handleChangeCH(event) {    this.setState({Curriculumopen_CH: event.target.value});  }
  handleChangeNUM(event) {    this.setState({Curriculumopen_NUM: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
 // handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
  handleChangeEND(event) {    this.setState({Curriculumopen_Date_END: event.target.value});  }

  handleChangeTIMESTARTRE(event) {    this.setState({Curriculumopen_Date_STARTRE: event.target.value});  }
  handleChangeENDRE(event) {    this.setState({Curriculumopen_Date_ENDRE: event.target.value});  }



  handleChangenameshortterm(event) {    this.setState({Shortcoursemd_Nameshort_TH: event.target.value});  }
  handleChangenameshorttermen(event) {    this.setState({Shortcoursemd_Nameshort_EN: event.target.value});  }
  handleChangeDetail_TH(event) {    this.setState({Curriculumopen_Detail_THshort: event.target.value});  }
  handleChangeDetail_EN(event) {    this.setState({Curriculumopen_Detail_ENshort: event.target.value});  }
  handleChangech(event) {    this.setState({Shortcoursemd_Numch: event.target.value});  }
  handleChangeregis(event) {    this.setState({Shortcoursemd_Numregis: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({Shortcoursemd_Timestart: event.target.value});  }
  handleChangeEND(event) {    this.setState({Shortcoursemd_Timeend: event.target.value});  }





  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                    datafrm.append("Shortcourse_ID", this.state.Shortcourse_ID);
                    datafrm.append("Shortcoursemd_Course_ID", this.state.Shortcoursemd_Course_ID);
                    datafrm.append("Shortcoursemd_Nameshort_TH", this.state.Shortcoursemd_Nameshort_TH);
                    datafrm.append("Shortcoursemd_Nameshort_EN", this.state.Shortcoursemd_Nameshort_EN);
                    datafrm.append("Curriculumopen_Detail_THshort", this.state.Curriculumopen_Detail_THshort);
                    datafrm.append("Curriculumopen_Detail_ENshort", this.state.Curriculumopen_Detail_ENshort);
                    datafrm.append("Shortcoursemd_Numch", this.state.Shortcoursemd_Numch);
                    datafrm.append("Shortcoursemd_Numregis", this.state.Shortcoursemd_Numregis);
                    datafrm.append("Shortcoursemd_Timestart", this.state.Shortcoursemd_Timestart);
                    datafrm.append("Shortcoursemd_Timeend", this.state.Shortcoursemd_Timeend);
                    datafrm.append("Shortcoursemd_Userupdate", this.state.Shortcoursemd_Userupdate);
                    datafrm.append("Shortcoursemd_Status_ONOFF", this.state.Shortcoursemd_Status_ONOFF);
                    datafrm.append("Shortcoursemd_Univ_id", this.state.Shortcoursemd_Univ_id);
      
    api.post("index/updateShortcoursemd/",datafrm,{
        headers: {
            'content-type': 'multipart/form-data'
        }
      })

   .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")
                  Swal.fire({
                      title: 'แก้ไขข้อมูลสำเร็จ',
                      icon: 'success',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                   
                 this.getCurriculumopen();
                 this.props.showshortcoursemd(); 
                 this.toggle();
                
                    })
                 }
        })
       
      //  this.props.getclassroom()

}, 1000);

//window.location.href = '/Reportcurriculumall'
//this.props.updateat();
//this.getExpert()
 
  }

    render() {
     



      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
        
        return (
            <>
          
            <MDBBtn  onClick={this.toggle} color="amber" size="sm" >แก้ไข</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}><MDBIcon icon="edit" /> แก้ไขข้อมูลหลักสูตรระยะสั้น</MDBModalHeader>
              <MDBModalBody>
                       
                                <MDBRow>
                                <MDBCol sm="12">
                                <div className="form-group">
                                    <label htmlFor="example2">รหัสวิชาหลัก</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.props.Shortcoursemd_Course_ID}  disabled />
                                </div>
                               
                               
                                <div className="form-group">
                                    <label htmlFor="example2">ชื่อหลักสูตรระยะสั้น ภาษาไทย</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Nameshort_TH} onChange={this.handleChangenameshortterm}  />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">ชื่อหลักสูตรระยะสั้น ภาษาอังกฤษ</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Nameshort_EN} onChange={this.handleChangenameshorttermen}  />
                                </div>
                                {/* <div className="form-group">
                                    <label htmlFor="example2">จำนวนหน่วยกิต</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Credit} onChange={this.handleChangeCredit} disabled />
                                </div> */}
                                <div>
                                    <div className="form-group text-left">
                                <label htmlFor="example2">คำอธิบายรายวิชาหลักสูตรระยะสั้นภาษาไทย</label>
                                <textarea
                                  className="form-control"
                                  id="exampleFormControlTextarea1"
                                  placeholder="คำอธิบายรายวิชาหลักสูตรระยะสั้นภาษาไทย"
                                  value={this.state.Curriculumopen_Detail_THshort} onChange={this.handleChangeDetail_TH} 
                                  rows="5"
                                  />
                            </div>
                            <div className="form-group text-left">
                                <label htmlFor="example2">คำอธิบายรายวิชาหลักสูตรระยะสั้นภาษาอังกฤษ</label>
                                <textarea
                                  className="form-control"
                                  id="exampleFormControlTextarea1"
                                  placeholder="คำอธิบายรายวิชาหลักสูตรระยะสั้นภาษาอังกฤษ"
                                  value={this.state.Curriculumopen_Detail_ENshort} onChange={this.handleChangeDetail_EN} 
                                  rows="5"
                                  />
                            </div>

                                <div className="form-group">
                                    <label htmlFor="example2">จำนวนชั่วโมง</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Numch} onChange={this.handleChangech}  />
                                </div>    

                            
                                </div>
                               
                               
                                <div className="form-group">
                                    <label htmlFor="example2">จำนวนที่รับ</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Shortcoursemd_Numregis} onChange={this.handleChangeregis} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">วันที่ เปิดการสอน</label>
                                    <input type="date" id="example2" className="form-control form-control-md" value={this.state.Shortcoursemd_Timestart} onChange={this.handleChangeTIMESTART} required/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="example2">วันที่ ปิดการสอน</label>
                                    <input type="date" id="example2" className="form-control form-control-md" value={this.state.Shortcoursemd_Timeend}  onChange={this.handleChangeEND} required/>
                                </div>
                                {/* <div className="form-group">
                                    <label htmlFor="example2">มหาวิทยาลัย</label>
                                    <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ รายละเอียด" value={this.state.Univ_NAME} disabled />
                                </div> */}
                                </MDBCol>
                                </MDBRow>

                        </MDBModalBody>
              <MDBModalFooter>
                
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึกการแก้ไข</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
